module.exports = __webpack_public_path__ + "img/qrPlaceholder.f1faa8d6.png";